import { getLocalStorage, setLocalStorage } from "../utils/localStorage";

export {
  filterReleaseItems,
  normalizeReleaseData,
} from "../hooks/useReleaseData";
export type {
  NormalizedRelease,
  NormalizedReleaseItem,
  ReleaseNotesState,
} from "../types/releaseData";

export const formatReleaseDate = (dateString?: string): string => {
  if (!dateString) return "Unknown date";

  const parsed = new Date(dateString);
  if (Number.isNaN(parsed.getTime())) return dateString;

  return new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  }).format(parsed);
};

export function isReleaseSeenByUser(hashKey: string, businessUserId: string): boolean {
  if (!hashKey || !businessUserId) return false;

  try {
    const seenMap = JSON.parse(getLocalStorage("ReleaseNotes") || "{}");
    const storedHash = seenMap[businessUserId];
    return storedHash === hashKey;
  } catch (e) {
    return false;
  }
}

export function markReleaseAsSeen(hashKey: string, businessUserId?: string) {
  if (!hashKey || !businessUserId) return;

  try {
    const raw = getLocalStorage("ReleaseNotes") || "{}";
    const seenMap = JSON.parse(String(raw)) || {};

    if (businessUserId) {
      seenMap[businessUserId] = hashKey;
    }
    setLocalStorage("ReleaseNotes", JSON.stringify(seenMap));
  } catch {
    // no-op: storage is best-effort and must be resilient offline
  }
}
